<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-12 form-group">
          <div class="declaration-search">
            <auto-complete :get-data="loadDeclarations" :min-symbols="3" :result="selectDeclaration" :item-text="itemText" placeholder="Sisesta tolliviide"/>
          </div>
        </div>
      </div>
      <div class="row" v-if="declaration">
        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>Tolliviide</dt>
              <dd>{{declaration.customsReference}}</dd>
            </dl>
            <dl>
              <dt>Kliendi nimi</dt>
              <dd>{{declaration.clientName}}</dd>
            </dl>
            <dl>
              <dt>Protseduur</dt>
              <dd>{{declaration.direction}}</dd>
            </dl>
          </div>
        </div>
        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>Viide</dt>
              <dd>{{declaration.reference}}</dd>
            </dl>
            <dl>
              <dt>Staatus</dt>
              <dd><span class="badge badge-lg"
                        :class="{'badge-danger': !declaration.invoiceCreationAllowed, 'badge-light': declaration.invoiceCreationAllowed}">
                {{declaration.status}}</span></dd>
            </dl>
            <dl>
              <dt>Aeg</dt>
              <dd>{{declaration.date | formatDateTime}}</dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary" :disabled="!declaration || !declaration.invoiceCreationAllowed">Lisa arvele</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import AutoComplete from '@/components/AutoComplete'
  import gateway from '@/services/gateway'

  export default {
    props: ['invoice'],
    components: {AutoComplete},
    data() {
      return {
        declaration: null
      }
    },
    methods: {
      loadDeclarations(query) {
        return gateway.get('/declarations?query=' + query).then(r => r.data)
      },
      itemText(item) {
        return `${item.customsReference} - ${item.clientName}`
      },
      selectDeclaration(val) {
        this.declaration = val
      },
      submit() {
        gateway
          .post(`/invoices/${this.invoice.id}/add-declarations`, {declarationIds: [this.declaration.id]})
          .then(() => this.$emit('done'))
      },
      asSelectOptions: (services) => {
        return services.map(service => {
          return {
            value: service.id,
            text: service.name
          }
        })
      }
    }
  }
</script>
